module.exports = "../dist/frontend/icons/benefits/green/download.svg?0f226675dd405530ae6262e906881d49";